import { SVGProps } from 'react';

interface IconPencilProp extends SVGProps<SVGSVGElement> {
  dataTestId?: string;
}
export const IconPencil = ({ dataTestId = '', ...props }: IconPencilProp) => {
  return (
    <svg viewBox='0 0 20 20' fill='none' data-testid={dataTestId} {...props}>
      <path
        d='M10.6105 6.55646L13.4435 9.38953L6.83306 16H4V13.1669L10.6105 6.55646ZM11.5548 5.61211L12.9713 4.19558C13.2322 3.93481 13.6549 3.93481 13.9157 4.19558L15.8044 6.08429C16.0652 6.34506 16.0652 6.76786 15.8044 7.02863L14.3878 8.44516L11.5548 5.61211Z'
        fill='currentColor'
      />
    </svg>
  );
};
